import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  COLORS,
  GenericIconName,
  Icon,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useHelpCenterChatbot} from './hooks/useHelpCenterChatbot';
import {useHelpCenterChatbotActive} from './hooks/useHelpCenterChatbotActive';

export const HelpCenterChatbotSection: React.FC<{className?: string}> = ({
  className,
}) => {
  const {t} = useTranslation();
  const {open, isOpening} = useHelpCenterChatbot();
  const {
    isActiveForApp: isHelpCenterChatbotActiveForApp,
    appIntent: helpCenterChatbotAppIntent,
  } = useHelpCenterChatbotActive();

  const openChatbot = () => {
    if (isHelpCenterChatbotActiveForApp && helpCenterChatbotAppIntent) {
      window.location.href = helpCenterChatbotAppIntent;
      return;
    }

    open();
  };

  return (
    <Wrapper className={className} data-testid="helpCenterChatbotSection">
      <TextWrapper>
        <Title>
          <Icon asset={GenericIconName.Chatbot} size="M" />
          <Text size="px18" weight="mediumHeavy">
            {t('Chat with us')}
          </Text>
        </Title>
        <Subtitle>
          <Text color="Grey0">{t("Didn't find what you looked for?")}</Text>
          <Text color="Grey0">{t('Ask our Chatbot KAY!')}</Text>
        </Subtitle>
      </TextWrapper>
      <StyledLoadingButton isLoading={isOpening} onClick={openChatbot}>
        {t('Start chat')}
      </StyledLoadingButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${COLORS.Grey4};
  border-radius: 4px;
  padding: 20px;
  gap: 24px;

  ${tabletAndUpLinaria(`
    flex-direction: row;
    align-items: center;
    padding: 24px;
    gap: 8px;
  `)}
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${tabletAndUpLinaria(`
    gap: 8px;
    flex: 1 0 60%;
  `)}
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Subtitle = styled.div`
  display: flex;
  flex-direction: column;

  > span {
    line-height: 1.5;
  }
`;

const StyledLoadingButton = styled(Button)`
  white-space: nowrap;
  > span {
    white-space: nowrap;
  }
`;
